import { Tab, Tabs, Card, CardBody, Button, Input, Popover, PopoverContent, PopoverTrigger } from "@nextui-org/react"
import { MainContainer } from "../../components"
import { DashboardPayable } from "./DashboardPayable"
import { DashboardReceivable } from "./DashboardReceivable"
import { useSelector } from "react-redux"
import { DashboardCombineOutstanding } from "./DashboardCombineOutstanding"
import { ENUM_ENCRYPT_CODE } from "../../constants/enum"
import { faFilter, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useRef, useState } from "react"
import { useModalToast } from "../../components/modalToast/ModalToastContext"
const DashboardOutstanding = () => {
  const outPData = useSelector((state) => state.outstandingPayable)
  const outRData = useSelector((state) => state.outstandingReceivable)
  const [filterAging, setFilterAging] = useState({ age1: 45, age2: 60, age3: 90, age4: 120 })
  const [propAging, setPropAging] = useState({ age1: 45, age2: 60, age3: 90, age4: 120 })
  const [selKey, setSelKey] = useState("")
  const inputRef = useRef(null);
  const [msg, setMsg] = useState("")
  const { show } = useModalToast()

  let tabs = [
    {
      id: "Payable",
      label: "Payable",
      content: <DashboardPayable propAging={propAging} />
    },
    {
      id: "Receivable",
      label: "Receivable",
      content: <DashboardReceivable propAging={propAging} />
    },
    {
      id: "CombineOutStanding",
      label: "Combine",
      content: <DashboardCombineOutstanding />
    }
  ]
  const handleAgingChange = (e) => {
    const { value, name } = e.target
    setFilterAging({ ...filterAging, [name]: value })
  }
  const handleAgingFilter = () => {
    const newErrors = {
      age1: "",
      age2: "",
      age3: "",
      age4: "",
    };

    let isValid = true;

    const age1 = Number(filterAging.age1);
    const age2 = Number(filterAging.age2);
    const age3 = Number(filterAging.age3);
    const age4 = Number(filterAging.age4);
    if (age1 >= age2) {
      isValid = false;
      newErrors.age1 = `Value of Age 1 must be < Age 2 (${age2})`;
    }

    // Age 2
    if (age2 <= age1) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be > Age 1 (${filterAging.age1})`;
    } else if (age2 >= age3) {
      isValid = false;
      newErrors.age2 = `Value of Age 2 must be < Age 3 (${age3})`;
    }

    // Age 3
    if (age3 <= age2) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be > Age 2 (${age2})`;
    } else if (age3 >= age4) {
      isValid = false;
      newErrors.age3 = `Value of Age 3 must be < Age 4 (${age4})`;
    }
    if (!isValid) {
      show(<div><h6> {newErrors.age1}</h6>
        <h6> {newErrors.age2}</h6>
        <h6> {newErrors.age3}</h6>
        <h6> {newErrors.age4}</h6>

      </div>)
      return;
    }
    setPropAging(filterAging);
  }
  const handleResetFilter = () => {
    const filter = { age1: 45, age2: 60, age3: 90, age4: 120 }
    setFilterAging(filter)
    setPropAging(filter)
  }
  const handleAgeBlur = (e) => {
    const { name, value } = e.target;
    const currentValue = Number(value);



    let message = "";

    // if (name === "age1") {
    //   if (currentValue >= Number(filterAging.age2)) {
    //     message = `Value of Age 1 must be < Age 2 (${filterAging?.age2})`;
    //   }
    // }

    // if (name === "age2") {
    //   if (currentValue <= Number(filterAging?.age1)) {
    //     message = `Value of Age 2 must be > Age 1 (${filterAging.age1})`;
    //   } else if (currentValue >= Number(filterAging?.age3)) {
    //     message = `Value of Age 2 must be < Age 3 (${filterAging.age3})`;
    //   }
    // }

    // if (name === "age3") {
    //   if (currentValue <= Number(filterAging?.age2)) {
    //     message = `Value of Age 3 must be > Age 2 (${filterAging.age2})`;
    //   } else if (currentValue >= Number(filterAging?.age4)) {
    //     message = `Value of Age 3 must be < Age 4 (${filterAging.age4})`;
    //   }
    // }

    // if (name === "age4") {
    //   if (currentValue <= Number(filterAging?.age3)) {
    //     message = `Value of Age 4 must be > Age 3 (${filterAging.age3})`;
    //   }
    // }

    // if (message) {
    //   setMsg(message);


    //   return;
    // }

    // setMsg("");
  };
  return (
    <div>
      <div className="w-full">
        {selKey == "CombineOutStanding" ? "" :
          <div className="flex justify-end">
            <Popover placement="bottom" variant="bordered"
              //isDismissable={false}
              shouldCloseOnBlur={false}
              shouldBlockScroll={true}
              shouldCloseOnScroll={false}
              showArrow={true}>
              <PopoverTrigger>

                <button
                  type="button"

                  className="inline-flex items-center justify-end gap-2
                                                rounded-md
                                                border border-orange-200
                                                bg-orange-50
                                                px-2 py-1 
                                                text-xs uppercase font-medium text-orange-600
                                                shadow-sm
                                                transition-all duration-200
                                                hover:border-orange-300
                                                hover:bg-orange-100
                                                hover:text-orange-800
                                                hover:shadow
                                                focus:outline-none
                                                ring-2 ring-orange-400 focus:ring-offset-1
                                                active:scale-[0.98]
                                            "
                >
                  <FontAwesomeIcon
                    icon={faFilter}
                    className="text-orange-600  font-semibold"
                  />

                  <span> Filter Aging</span>
                </button>


              </PopoverTrigger>
              <PopoverContent className="z-[1000]">
                <div
                  className="p-2"
                  onMouseDown={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                >

                  {msg && <div className="text-red-500 bg-red-50 text-sm p-1">{msg}</div>}
                  <div className="grid grid-cols-2 gap-x-3 gap-y-2">
                    <Input
                      type="text"
                      label="Age 1"
                      name="age1"
                      ref={inputRef}
                      color="success"
                      isRequired
                      placeholder=" "
                      variant="bordered"
                      labelPlacement="outside"
                      className="w-20 bg-white"
                      classNames={{
                        label: "text-xs font-semibold text-orange-600 uppercase",
                        input: "text-sm font-semibold",
                      }}
                      size="sm"
                      value={filterAging?.age1 ?? ""}
                      onBlur={handleAgeBlur}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleAgingChange(e)}
                    />

                    <Input
                      type="text"
                      label="Age 2"
                      name="age2"
                      color="success"
                      ref={inputRef}
                      isRequired
                      placeholder=" "
                      variant="bordered"
                      labelPlacement="outside"
                      className="w-20 bg-white"
                      classNames={{
                        label: "text-xs font-semibold text-orange-600 uppercase",
                        input: "text-sm font-semibold",
                      }}
                      size="sm"
                      value={filterAging?.age2 ?? ""}
                      onBlur={handleAgeBlur}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleAgingChange(e)}
                    />

                    <Input
                      type="text"
                      label="Age 3"
                      name="age3"
                      color="success"
                      ref={inputRef}
                      isRequired
                      placeholder=" "
                      variant="bordered"
                      labelPlacement="outside"
                      className="w-20 bg-white"
                      classNames={{
                        label: "text-xs font-semibold text-orange-600 uppercase",
                        input: "text-sm font-semibold",
                      }}
                      size="sm"
                      value={filterAging?.age3 ?? ""}
                      onBlur={handleAgeBlur}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleAgingChange(e)}
                    />

                    <Input
                      type="text"
                      label="Age 4"
                      name="age4"
                      color="success"
                      isRequired
                      ref={inputRef}
                      placeholder=" "
                      variant="bordered"
                      labelPlacement="outside"
                      className="w-20 bg-white"
                      classNames={{
                        label: "text-xs font-semibold text-orange-600 uppercase",
                        input: "text-sm font-semibold",
                      }}
                      size="sm"
                      value={filterAging?.age4 ?? ""}
                      onBlur={handleAgeBlur}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => handleAgingChange(e)}
                    />
                  </div>


                  <div className="mt-5 flex justify-center gap-2 border-t border-gray-200 pt-3">


                    <Button
                      onPress={handleAgingFilter}
                      color="danger"
                      variant="shadow"
                      size="sm"
                      className="font-semibold h-7"

                    >
                      Apply
                    </Button>
                    <Button
                      onPress={handleResetFilter}
                      color="warning"
                      variant="flat"
                      size="sm"
                      className="font-semibold h-7"
                    >
                      Reset
                    </Button>
                  </div>


                </div>
              </PopoverContent>
            </Popover >
          </div>}
      </div>
      <div className="flex w-full flex-col">
        <Tabs aria-label="Dynamic tabs" color="danger" radius="none" items={tabs} variant="bordered"
          onSelectionChange={setSelKey}
          defaultSelectedKey={(outPData && outPData.isFromDashboard) ? "Payable"
            : (outRData && outRData?.isFromDashboard || outRData && outRData?.mainDsbRediKey == ENUM_ENCRYPT_CODE.receivable) ? "Receivable" :
              (outRData && outRData?.mainDsbRediKey == ENUM_ENCRYPT_CODE.difference) ? "CombineOutStanding" :
                ""}
        >
          {(item) => (
            <Tab key={item.id} title={item.label}>
              {item.content}
            </Tab>
          )}
        </Tabs>
      </div>


    </div >
  )
}
export default DashboardOutstanding
